import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

/**
 * Returns whether the current user is eligible for the 7-day free trial.
 * Eligible = never consumed a trial AND never had any subscription row.
 * Decision is server-side via RPC `is_trial_eligible(uuid)`.
 */
export function useTrialEligibility() {
  const { user } = useAuth();
  const [eligible, setEligible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;
    if (!user?.id) {
      setEligible(false);
      setLoading(false);
      return;
    }
    setLoading(true);
    supabase
      .rpc("is_trial_eligible", { _user_id: user.id })
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) {
          console.warn("[useTrialEligibility] RPC error", error);
          setEligible(false);
        } else {
          setEligible(Boolean(data));
        }
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [user?.id]);

  return { eligible, loading };
}
